const option_wraper = document.querySelector('[option_dropdown]');

if (option_wraper) {
  const option_item = option_wraper.querySelectorAll('[selling_input]');

  option_item.forEach(item => {
    item.addEventListener('change', (e) => {
      const selling_id = e.target.dataset.sellingPlanId;

      let is_check = false;

      const input_main = document.querySelector('.appstle_subscription_wrapper');
      if (!input_main) return;

      const select = input_main.querySelector('.appstle_custom_select select');
      const check_div = input_main.querySelector('.appstle_include_dropdown');

      console.log("check_div",check_div,check_div.classList.contains('appstle-active-option'))

      // Dropdown already active
      if (check_div && check_div.classList.contains('appstle-active-option')) {
        is_check = true;
      } else {
        // Click the subscription option first
        const input = input_main.querySelector(
          '.appstle_subscription_wrapper_option.appstle_include_dropdown input'
        );

        console.log("input", input);

        if (input) {
          input.checked = true;
          input.click();
          is_check = true;
        }
      }

      if (is_check && select) {
        console.log("is_true");

        select.value = selling_id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
}

const oneTime = document.querySelector('[one_time_subscription]');
if (oneTime) {
    oneTime.addEventListener('change', (e) => {
        const input_main = document.querySelector('.appstle_subscription_wrapper');

        if (input_main) {
        const input = [...input_main.querySelectorAll('.appstle_subscription_wrapper_option input')]
            .find(input => !input.value);

        console.log(input);
        if (input) {
    input.click();
  }
        }
    });
}


function toggleSubscription(btn, isOpen) {
  const parent = btn.closest("[subscription_widget]");

  const ul = parent.querySelector("[data-selling-plan-ul]");
  const editBtn = parent.querySelector("[edit_btn]");
  const closeBtn = parent.querySelector("[close_btn]");

  if (isOpen) {
    ul.classList.remove("hidden");
    closeBtn.classList.remove("hidden");
    editBtn.classList.add("hidden");
  } else {
    ul.classList.add("hidden");
    editBtn.classList.remove("hidden");
    closeBtn.classList.add("hidden");
  }
}


function sellingPlanChange(event) {
  const data = {
    line: event.target.dataset.line,
    quantity: event.target.dataset.quantity,
    selling_plan: event.target.value || null
  };

  console.log("data", data);

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(data)
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then(err => Promise.reject(err));
      }
      return response.json();
    })
    .then(() => {
      return fetch("/?sections=cart-drawer,cart-icon-bubble");
    })
    .then((response) => response.json())
    .then((sections) => {
      const cartDrawer = document.querySelector("cart-drawer");

      // Use the theme's own renderer so ONLY the inner section content is
      // swapped. Passing `false` keeps the drawer open and preserves the
      // single overlay/wrapper (avoids duplicating `.page-overlay-cart`).
      if (cartDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents({ sections }, false);
        return;
      }

      // Fallback: extract inner content manually if the custom element
      // isn't available for some reason.
      const parser = new DOMParser();

      const drawer = document.querySelector("#CartDrawer");
      if (drawer && sections["cart-drawer"]) {
        const parsedDrawer = parser
          .parseFromString(sections["cart-drawer"], "text/html")
          .querySelector("#CartDrawer");
        if (parsedDrawer) drawer.innerHTML = parsedDrawer.innerHTML;
      }

      const bubble = document.getElementById("cart-icon-bubble");
      if (bubble && sections["cart-icon-bubble"]) {
        const parsedBubble = parser
          .parseFromString(sections["cart-icon-bubble"], "text/html")
          .querySelector(".shopify-section");
        if (parsedBubble) bubble.innerHTML = parsedBubble.innerHTML;
      }
    })
    .catch((error) => {
      console.error("Cart Error:", error);
    });
}


/* ------------------------------------------------------------------
   Sticky subscription bar (Figma)
   - Desktop: "One-Time" pill + "Subscribe & Save" pill. Clicking the
     Subscribe pill opens a dropdown of the plan frequencies (1 month …).
   - Mobile: a single "SUBSCRIBE" toggle opens a dropdown with every
     option (One-Time + frequencies).
   The real radios live in the dropdown panel; the desktop One-Time pill
   proxies to the hidden one-time radio. Selecting any option updates the
   sticky "BUY - $XX" price, sets the active pill, and closes the dropdown.
   The radio `change` events also drive the subscription sync at the top.
------------------------------------------------------------------ */
document.querySelectorAll(".wt-sticky-sub").forEach((widget) => {
  const bar = widget.closest(".wt-product__sticky-buy");

  const setButtonPrice = (price) => {
    if (!bar || !price) return;
    bar.querySelectorAll(".js-sticky-buy-price").forEach((el) => {
      el.textContent = price;
    });
  };

  widget.querySelectorAll(".selling_plan_theme_integration").forEach((section) => {
    const subPill = section.querySelector(".wt-sticky-sub__pill--subscribe");
    const onePill = section.querySelector(".wt-sticky-sub__pill--onetime");
    const toggle = section.querySelector(".wt-sticky-sub__toggle");

    const close = () => {
      widget.classList.remove("is-open");
      section
        .querySelectorAll('[aria-expanded="true"]')
        .forEach((el) => el.setAttribute("aria-expanded", "false"));
    };
    const open = (trigger) => {
      widget.classList.add("is-open");
      if (trigger) trigger.setAttribute("aria-expanded", "true");
    };
    const setActive = (mode) => {
      if (onePill) onePill.classList.toggle("is-active", mode === "onetime");
      if (subPill) subPill.classList.toggle("is-active", mode === "subscribe");
    };

    // Desktop: One-Time pill selects the (hidden) one-time radio.
    if (onePill) {
      onePill.addEventListener("click", () => {
        const radio = section.querySelector(".wt-sticky-sub__opt--onetime input");
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    // Desktop: Subscribe pill toggles the frequency dropdown.
    if (subPill) {
      subPill.addEventListener("click", (e) => {
        e.stopPropagation();
        widget.classList.contains("is-open") ? close() : open(subPill);
      });
    }

    // Mobile: single toggle opens the full options dropdown.
    if (toggle) {
      toggle.addEventListener("click", (e) => {
        e.stopPropagation();
        widget.classList.contains("is-open") ? close() : open(toggle);
      });
    }

    // Any option chosen -> price, active state, close.
    section.querySelectorAll(".wt-sticky-sub__opt input").forEach((input) => {
      input.addEventListener("change", () => {
        const opt = input.closest(".wt-sticky-sub__opt");
        if (opt) setButtonPrice(opt.getAttribute("data-price"));
        setActive(input.hasAttribute("one_time_subscription") ? "onetime" : "subscribe");
        close();
      });
    });

    // Initial price + active state from whichever option is checked.
    const checked = section.querySelector(".wt-sticky-sub__opt input:checked");
    if (checked) {
      const opt = checked.closest(".wt-sticky-sub__opt");
      if (opt) setButtonPrice(opt.getAttribute("data-price"));
      setActive(checked.hasAttribute("one_time_subscription") ? "onetime" : "subscribe");
    }
  });
});

// Close any open sticky dropdown when clicking outside of it.
document.addEventListener("click", (e) => {
  document.querySelectorAll(".wt-sticky-sub.is-open").forEach((widget) => {
    if (!widget.contains(e.target)) {
      widget.classList.remove("is-open");
      widget
        .querySelectorAll('[aria-expanded="true"]')
        .forEach((el) => el.setAttribute("aria-expanded", "false"));
    }
  });
});


/* ── Appstle purchase-option sliding pill ───────────────────────────────────
   The widget (WIDGET_TYPE_7) marks the chosen option with .appstle-active-option
   and main.css paints that option white, so the highlight jumped between the two
   halves. Instead the wrapper draws ONE pill (its ::after, see custom.css) and we
   slide it onto whichever option is active by writing its measured position/width
   into --appstle-pill-x / --appstle-pill-w.

   Measured rather than a CSS-only :has() trick because the widget is app-injected:
   option count, order (main.css flips it with row-reverse) and label widths are
   all outside our control, and Appstle re-renders the whole widget on variant
   change — so we observe instead of assuming. */
(() => {
  const WRAPPER = ".appstle_sub_widget .appstle_subscription_wrapper";
  const OPTION = ".appstle_subscription_wrapper_option";
  const ACTIVE = ".appstle-active-option, .appstle_selected_background";
  const tracked = new WeakSet();

  const activeOption = (wrapper) => {
    const options = [...wrapper.querySelectorAll(OPTION)];
    if (!options.length) return null;
    return (
      options.find((o) => o.matches(ACTIVE)) ||
      options.find((o) => o.querySelector("input:checked")) ||
      options[0]
    );
  };

  const place = (wrapper, animate) => {
    const option = activeOption(wrapper);
    if (!option) return;

    const box = wrapper.getBoundingClientRect();
    const target = option.getBoundingClientRect();
    if (!target.width) return; // widget still laying out / hidden

    // Our own class/style writes are seen by the observer below; bail on a
    // no-op so it can't feed itself.
    const key = `${target.left - box.left}|${target.width}`;
    if (wrapper.dataset.appstlePill === key) return;
    wrapper.dataset.appstlePill = key;

    // First placement must not slide in from the left edge.
    if (!animate) wrapper.classList.add("appstle-pill-instant");
    wrapper.style.setProperty("--appstle-pill-x", `${target.left - box.left}px`);
    wrapper.style.setProperty("--appstle-pill-w", `${target.width}px`);
    wrapper.classList.add("appstle-pill-ready");
    if (!animate) {
      // Next frame: commit the position, then re-enable the transition.
      requestAnimationFrame(() =>
        requestAnimationFrame(() =>
          wrapper.classList.remove("appstle-pill-instant"),
        ),
      );
    }
  };

  const track = (wrapper) => {
    if (tracked.has(wrapper)) return;
    tracked.add(wrapper);

    place(wrapper, false);

    // Appstle toggles the active class on click; catch it however it happens.
    new MutationObserver(() => place(wrapper, true)).observe(wrapper, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "checked"],
    });
    wrapper.addEventListener("change", () => place(wrapper, true));
    // Label text/price changes and breakpoint changes resize the halves.
    if (window.ResizeObserver) {
      new ResizeObserver(() => place(wrapper, false)).observe(wrapper);
    }
  };

  const scan = () => document.querySelectorAll(WRAPPER).forEach(track);

  // The document-wide observer fires on any DOM churn, so coalesce to one scan
  // per frame instead of running querySelectorAll per mutation batch.
  let queued = false;
  const scanSoon = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  };

  scan();
  // The widget is injected (and re-injected on variant change) after load.
  new MutationObserver(scanSoon).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();